// src/components/Auth/Login.jsx
import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";

import "./Auth.css";
import logoGrowly from "../assets/logo-growly.svg";
import supabase from "../../services/supabase";

const Login = () => {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });

  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleLogin = async (e) => {
    e.preventDefault();

    if (!supabase) {
      setError("Serviço de autenticação indisponível no momento.");
      return;
    }

    if (!formData.email || !formData.password) {
      setError("Por favor, preencha email e senha.");
      return;
    }

    setError("");
    setIsLoading(true);

    try {
      const { data, error: supabaseError } =
        await supabase.auth.signInWithPassword({
          email: formData.email,
          password: formData.password,
        });

      if (supabaseError) throw supabaseError;

      if (data?.session) {
        localStorage.setItem("token", data.session.access_token);
        localStorage.setItem("refreshToken", data.session.refresh_token);
        localStorage.setItem("user", JSON.stringify(data.user));
      }

      navigate("/dashboard");
    } catch (err) {
      console.error(err);
      let msg = "Não foi possível fazer login.";

      if (err.message?.includes("Invalid login credentials")) {
        msg = "Email ou senha incorretos.";
      } else if (err.message?.includes("Email not confirmed")) {
        msg = "Confirme seu email antes de continuar.";
      }

      setError(msg);
    } finally {
      setIsLoading(false);
    }
  };

  const handleGoogleLogin = async () => {
    if (!supabase) {
      setError("Serviço de autenticação indisponível no momento.");
      return;
    }

    try {
      setError("");
      setIsLoading(true);

      await supabase.auth.signInWithOAuth({
        provider: "google",
      });
    } catch (err) {
      console.error(err);
      setError("Não foi possível iniciar o login com Google.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="login-figma-container">
      {/* Logo */}
      <img src={logoGrowly} alt="Growly" className="login-logo" />

      {/* Título */}
      <h1 className="login-title">Login na Growly</h1>

      {/* Erro */}
      {error && <div className="error-figma">{error}</div>}

      {/* Botão Google */}
      <button
        type="button"
        className="btn-google"
        onClick={handleGoogleLogin}
        disabled={isLoading}
      >
        Continuar com Google
      </button>

      {/* Form */}
      <form className="login-form" onSubmit={handleLogin}>
        <input
          type="email"
          name="email"
          className="input-figma"
          placeholder="Continuar com Email"
          value={formData.email}
          onChange={handleChange}
        />

        <input
          type="password"
          name="password"
          className="input-figma"
          placeholder="Login e Senha"
          value={formData.password}
          onChange={handleChange}
        />

        <button
          type="submit"
          className="btn-login"
          disabled={isLoading}
        >
          {isLoading ? "Entrando..." : "Login"}
        </button>
      </form>

      <p className="login-bottom-text">
        Não possui uma conta?{" "}
        <Link to="/register" className="login-bottom-link">
          Crie uma conta.
        </Link>
      </p>
    </div>
  );
};

export default Login;
